import { render } from "./InputRequiredTextArea.vue?vue&type=template&id=c59ccf4a&scoped=true"
import script from "./InputRequiredTextArea.vue?vue&type=script&lang=js"
export * from "./InputRequiredTextArea.vue?vue&type=script&lang=js"

import "./InputRequiredTextArea.vue?vue&type=style&index=0&id=c59ccf4a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2506568226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59ccf4a"]])

export default __exports__